// Copied From feaso/map-app-v2/src/Controls/Legend.js
import React, { useState, useEffect } from 'react';
import { Button, H4 } from '@blueprintjs/core';
import { makeStyles } from '@material-ui/core/styles';
import { has, isArray, isEmpty, isUndefined, startCase } from 'lodash';
import Grid from '@material-ui/core/Grid';

//TODO remove MUI
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    margin: 3
  },
  rootHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  gridRoot: {
    overflow: 'auto'
  },
  legendContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  legendItemSmall: {
    flex: '0 0 25%',
    display: 'flex',
    alignItems: 'center'
  },
  legendItemMedium: {
    flex: '0 0 50%',
    display: 'flex',
    alignItems: 'center'
  },
  legendItemLarge: {
    flex: '0 0 100%',
    display: 'flex',
    alignItems: 'center'
  },
  legendBox: {
    height: 12,
    width: 12,
    margin: 3,
    marginTop: 3,
    marginBottom: 3,
    alignSelf: 'center'
  },
  legendText: {
    maxWidth: '85%'
  },
}));

const parseMapBoxPaint = (paint, k) => {
  try {
    // first element is 'match' then ['get', 'SYM_CODE'], last is default. Ignore these.
    let [start, end] = [2, -1];
    if (paint[k][0] === 'interpolate') {
      [start, end] = [3, paint[k].length];
    }
    const legend = paint[k]
      .slice(start, end)
      .reduce((result, value, index, array) => {
        if (index % 2 === 0) {
          result[value] = array[index + 1];
        }
        return result;
      }, {});
    return legend;
  } catch (e) {
    console.log('unexpected color map in layer ', paint);
  }
};

export const findColor = layer => {
  const paint = isArray(layer) ? layer[0].paint : layer.paint;

  if (has(paint, 'fill-color')) {
    if (isArray(paint['fill-color'])) {
      return parseMapBoxPaint(paint, 'fill-color') || 'grey';
    }
    return paint['fill-color'];
  }
  if (has(paint, 'line-color')) {
    if (isArray(paint['line-color'])) {
      return parseMapBoxPaint(paint, 'line-color') || 'grey';
    }
    return paint['line-color'];
  }
  if (has(paint, 'fill-extrusion-color')) {
    if (isArray(paint['fill-extrusion-color'])) {
      return parseMapBoxPaint(paint, 'fill-extrusion-color') || 'grey';
    }
    return paint['fill-extrusion-color'];
  }
  return 'gray';
};

const isPaint = style => {
  const s = isArray(style) ? style[0] : style;
  return !isUndefined(s.paint) && s.type !== 'raster';
};

const isMapServer = style => {
  const tiles = isArray(style) ? style[0].source.tiles : style.source.tiles;
  return !(isEmpty(tiles)) && tiles[0].includes('MapServer');
};

const isUploadedLayer = style => {
  // is this from layers-app ?
  return (
    !isArray(style)
    && style.type === 'raster'
    && style.source.url
    && (
      style.source.url.startsWith('https://storage.googleapis.com/feaso-dev/')
      || style.source.url.startsWith('https://storage.googleapis.com/feaso-prod/')
    )
  );
};


const PaintLegend = ({ layer }) => {
  const classes = useStyles();
  const legend = findColor(layer);
  return (typeof legend === 'object' && (
    <Grid className={classes.gridRoot} item xs={12}>
      <div className={classes.legendContainer}>
        {Object.keys(legend).map(text => {
          const itemStyle = text.length <= 4
            ? classes.legendItemSmall
            : text.length <= 15
              ? classes.legendItemMedium
              : classes.legendItemLarge;
          return (
            <div key={text} className={itemStyle}>
              <div
                className={classes.legendBox}
                style={{ backgroundColor: legend[text] }}
              />
              <span className={classes.legendText}>
                {text}
              </span>
            </div>
          );
        })}
      </div>
    </Grid>
  ));
};

const MapServerLegend = ({ mSLegend }) => {
  const classes = useStyles();

  return mSLegend.map(layer => (
    <Grid className={classes.gridRoot} key={layer.layerId} item xs={12}>
      {layer.layerName}
      < div className={classes.legendContainer} >
        {
          layer.legend.map(legendItem => {
            const itemStyle = legendItem.label.length <= 4
              ? classes.legendItemSmall
              : legendItem.label.length <= 15
                ? classes.legendItemMedium
                : classes.legendItemLarge;
            return (
              <div key={legendItem.label} className={itemStyle}>
                <img
                  src={"data:image/png;base64," + legendItem.imageData}
                  className={classes.legendBox}
                // style={{ backgroundColor: legend[legendItem.label] }}
                />
                <span className={classes.legendText}>
                  {legendItem.label}
                </span>
              </div>
            );
          })
        }
      </div >
    </Grid>
  ));
};

export const getEsriBaseUrl = url => url.match(/.*\/MapServer\//);
export const getEsriShowLayerIds = url => {
  const show = url.match(/.*layers=show:(?<show>[\d,]*)/);
  if (show) return show.groups.show.split(',').map(d => Number(d));
  return null;
}

// load legend data from esri MapServer
const loadMapServer = (style) => {
  const tiles = isArray(style) ? style[0].source.tiles : style.source.tiles;
  const fullUrl = tiles[0];
  const baseUrl = getEsriBaseUrl(fullUrl);
  // can't do anything without baseUrl
  if (!baseUrl) return null;

  const showlayerIds = getEsriShowLayerIds(fullUrl)
  // if !show use all layers else filter by show.groups.show
  const filterFunc = showlayerIds === null
    ? () => true
    : l => (showlayerIds.indexOf(l.layerId) > -1);

  const legendUrl = baseUrl[0] + '/legend?f=json'
  return fetch(legendUrl)
    .then(resp => resp.json())
    .then(resp => {
      const mSLayers = resp['layers'].filter(filterFunc);
      return mSLayers;
    })
    .catch(e => {
      console.log(e);
      return []
    });

};


export const hasLegend = layer => (isPaint(layer)
  || isMapServer(layer)
  || isUploadedLayer(layer));


const Legend = ({ layer, setLegend }) => {
  const classes = useStyles();
  const [mSLegend, setMSLegend] = useState([]);

  useEffect(() => {
    if (isMapServer(layer)) {
      loadMapServer(layer).then(setMSLegend);
    }
  }, [layer]);

  return (
    <div className={classes.root}>
      <div className={classes.rootHeader}>
        <H4 style={{ margin: 0 }}>{layer.id.split(/[,-/\\]+/).map(startCase).join('/')}</H4>
        <Button small icon="cross" onClick={() => setLegend(undefined)} />
      </div>
      {
        (() => {
          if (isPaint(layer)) {
            return <PaintLegend layer={layer} />;
          }

          if (isMapServer(layer)) {
            return <MapServerLegend mSLegend={mSLegend} />;
          }

          return null;
        })()
      }
    </div>
  )
};

export default Legend;
